import { render, staticRenderFns } from "./LoanCollateralAssetVehicleFieldsEdit.vue?vue&type=template&id=5bf63cb8&scoped=true&lang=pug&"
import script from "./LoanCollateralAssetVehicleFieldsEdit.vue?vue&type=script&lang=js&"
export * from "./LoanCollateralAssetVehicleFieldsEdit.vue?vue&type=script&lang=js&"
import style0 from "./LoanCollateralAssetVehicleFieldsEdit.vue?vue&type=style&index=0&id=5bf63cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf63cb8",
  null
  
)

/* custom blocks */
import block0 from "./LoanCollateralAssetVehicleFieldsEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports